import { render, staticRenderFns } from "./ConnectSchedulePosts.vue?vue&type=template&id=1ae71735&scoped=true"
import script from "./ConnectSchedulePosts.vue?vue&type=script&lang=js"
export * from "./ConnectSchedulePosts.vue?vue&type=script&lang=js"
import style0 from "./ConnectSchedulePosts.vue?vue&type=style&index=0&id=1ae71735&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae71735",
  null
  
)

export default component.exports